import { StorageStrategy } from './StorageStrategy';
import StorageTransformer from './StorageTransformer';

class WindowNameStorage implements StorageStrategy {
  public store(key: string, data: string): void {
    const windowNameMap = StorageTransformer.getMapFromString(window.name, '&');
    const encodedKey = encodeURIComponent(key);
    const encodedValue = encodeURIComponent(data);
    windowNameMap.set(encodedKey, encodedValue);
    window.name = StorageTransformer.getStringFromMap(windowNameMap, '&');
  }

  public retrieve(key: string): string | undefined {
    const storageMap = StorageTransformer.getMapFromString(window.name, '&');
    const value = storageMap.get(encodeURIComponent(key));
    if (value === null || value === undefined) {
      return undefined;
    }

    return decodeURIComponent(value);
  }

  public remove(key: string): void {
    const windowNameMap = StorageTransformer.getMapFromString(window.name, '&');
    windowNameMap.delete(encodeURIComponent(key));
    window.name = StorageTransformer.getStringFromMap(windowNameMap, '&');
  }

  public static clear(): void {
    window.name = null;
  }
}

export default WindowNameStorage;
